import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "../../../api/constants";

export interface GeneratePDFRequest {
  session_id: string;
  message?: string;
  // Customer information fields (optional - will fallback to session data if not provided)
  first_name?: string;
  last_name?: string;
  title?: string;
  email?: string;
  phone?: string;
  company?: string;
  address?: string;
  country?: string;
}

/**
 * Generate a PDF summary from a quotation chat session.
 *
 * @param data - Request containing session_id and optional message
 * @param token - Authentication token
 * @returns AxiosResponse with PDF blob data
 */
export async function generatePDF(
  data: GeneratePDFRequest,
  token: string,
): Promise<AxiosResponse<Blob>> {
  return axios.post<Blob>(`${baseUrl}/api/v1/quotation-chat/generate-pdf`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });
}
